/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * AgencyOS API
 * API AgencyOS (/api/v1). Le client des apps est généré depuis ce schéma.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AiDraftRequest,
  Article,
  ArticleRequest,
  LocalPage,
  Offer,
  OfferRequest,
  PaginatedArticleList,
  PaginatedOfferList,
  PaginatedTestimonialList,
  PaginatedWebsiteSettingsList,
  PatchedArticleRequest,
  PatchedLocalPageRequest,
  PatchedOfferRequest,
  PatchedSiteSectionRequest,
  PatchedTestimonialRequest,
  PatchedWebsiteSettingsRequest,
  PreviewRequest,
  PreviewResult,
  PublishRequest,
  SiteMedia,
  SiteMediaRequest,
  SiteSection,
  Testimonial,
  TestimonialRequest,
  WebsiteBlogListParams,
  WebsiteOffersListParams,
  WebsiteSectionsListParams,
  WebsiteSettings,
  WebsiteSettingsListParams,
  WebsiteTestimonialsListParams
} from '.././model';

import { apiFetch } from '../../http';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export type websiteBlogListResponse200 = {
  data: PaginatedArticleList
  status: 200
}
    
export type websiteBlogListResponseSuccess = (websiteBlogListResponse200) & {
  headers: Headers;
};
;

export type websiteBlogListResponse = (websiteBlogListResponseSuccess)

export const getWebsiteBlogListUrl = (params?: WebsiteBlogListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/website/blog/?${stringifiedParams}` : `/api/v1/website/blog/`
}

export const websiteBlogList = async (params?: WebsiteBlogListParams, options?: RequestInit): Promise<websiteBlogListResponse> => {
  
  return apiFetch<websiteBlogListResponse>(getWebsiteBlogListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteBlogListQueryKey = (params?: WebsiteBlogListParams,) => {
    return [
    `/api/v1/website/blog/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getWebsiteBlogListQueryOptions = <TData = Awaited<ReturnType<typeof websiteBlogList>>, TError = unknown>(params?: WebsiteBlogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteBlogList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteBlogListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteBlogList>>> = ({ signal }) => websiteBlogList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteBlogList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteBlogListQueryResult = NonNullable<Awaited<ReturnType<typeof websiteBlogList>>>
export type WebsiteBlogListQueryError = unknown


export function useWebsiteBlogList<TData = Awaited<ReturnType<typeof websiteBlogList>>, TError = unknown>(
 params: undefined |  WebsiteBlogListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteBlogList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteBlogList>>,
          TError,
          Awaited<ReturnType<typeof websiteBlogList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteBlogList<TData = Awaited<ReturnType<typeof websiteBlogList>>, TError = unknown>(
 params?: WebsiteBlogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteBlogList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteBlogList>>,
          TError,
          Awaited<ReturnType<typeof websiteBlogList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteBlogList<TData = Awaited<ReturnType<typeof websiteBlogList>>, TError = unknown>(
 params?: WebsiteBlogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteBlogList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteBlogList<TData = Awaited<ReturnType<typeof websiteBlogList>>, TError = unknown>(
 params?: WebsiteBlogListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteBlogList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteBlogListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type websiteBlogCreateResponse201 = {
  data: Article
  status: 201
}
    
export type websiteBlogCreateResponseSuccess = (websiteBlogCreateResponse201) & {
  headers: Headers;
};
;

export type websiteBlogCreateResponse = (websiteBlogCreateResponseSuccess)

export const getWebsiteBlogCreateUrl = () => {


  

  return `/api/v1/website/blog/`
}

export const websiteBlogCreate = async (articleRequest: ArticleRequest, options?: RequestInit): Promise<websiteBlogCreateResponse> => {
  
  return apiFetch<websiteBlogCreateResponse>(getWebsiteBlogCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      articleRequest,)
  }
);}




export const getWebsiteBlogCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogCreate>>, TError,{data: ArticleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteBlogCreate>>, TError,{data: ArticleRequest}, TContext> => {

const mutationKey = ['websiteBlogCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteBlogCreate>>, {data: ArticleRequest}> = (props) => {
          const {data} = props ?? {};

          return  websiteBlogCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteBlogCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteBlogCreate>>>
    export type WebsiteBlogCreateMutationBody = ArticleRequest
    export type WebsiteBlogCreateMutationError = unknown

    export const useWebsiteBlogCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogCreate>>, TError,{data: ArticleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteBlogCreate>>,
        TError,
        {data: ArticleRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteBlogCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type websiteBlogRetrieveResponse200 = {
  data: Article
  status: 200
}
    
export type websiteBlogRetrieveResponseSuccess = (websiteBlogRetrieveResponse200) & {
  headers: Headers;
};
;

export type websiteBlogRetrieveResponse = (websiteBlogRetrieveResponseSuccess)

export const getWebsiteBlogRetrieveUrl = (id: string,) => {


  

  return `/api/v1/website/blog/${id}/`
}

export const websiteBlogRetrieve = async (id: string, options?: RequestInit): Promise<websiteBlogRetrieveResponse> => {
  
  return apiFetch<websiteBlogRetrieveResponse>(getWebsiteBlogRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteBlogRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/website/blog/${id}/`
    ] as const;
    }

    
export const getWebsiteBlogRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof websiteBlogRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteBlogRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteBlogRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteBlogRetrieve>>> = ({ signal }) => websiteBlogRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteBlogRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteBlogRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof websiteBlogRetrieve>>>
export type WebsiteBlogRetrieveQueryError = unknown


export function useWebsiteBlogRetrieve<TData = Awaited<ReturnType<typeof websiteBlogRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteBlogRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteBlogRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteBlogRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteBlogRetrieve<TData = Awaited<ReturnType<typeof websiteBlogRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteBlogRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteBlogRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteBlogRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteBlogRetrieve<TData = Awaited<ReturnType<typeof websiteBlogRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteBlogRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteBlogRetrieve<TData = Awaited<ReturnType<typeof websiteBlogRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteBlogRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteBlogRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type websiteBlogPartialUpdateResponse200 = {
  data: Article
  status: 200
}
    
export type websiteBlogPartialUpdateResponseSuccess = (websiteBlogPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type websiteBlogPartialUpdateResponse = (websiteBlogPartialUpdateResponseSuccess)

export const getWebsiteBlogPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/website/blog/${id}/`
}

export const websiteBlogPartialUpdate = async (id: string,
    patchedArticleRequest: PatchedArticleRequest, options?: RequestInit): Promise<websiteBlogPartialUpdateResponse> => {
  
  return apiFetch<websiteBlogPartialUpdateResponse>(getWebsiteBlogPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedArticleRequest,)
  }
);}




export const getWebsiteBlogPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogPartialUpdate>>, TError,{id: string;data: PatchedArticleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteBlogPartialUpdate>>, TError,{id: string;data: PatchedArticleRequest}, TContext> => {

const mutationKey = ['websiteBlogPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteBlogPartialUpdate>>, {id: string;data: PatchedArticleRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  websiteBlogPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteBlogPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteBlogPartialUpdate>>>
    export type WebsiteBlogPartialUpdateMutationBody = PatchedArticleRequest
    export type WebsiteBlogPartialUpdateMutationError = unknown

    export const useWebsiteBlogPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogPartialUpdate>>, TError,{id: string;data: PatchedArticleRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteBlogPartialUpdate>>,
        TError,
        {id: string;data: PatchedArticleRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteBlogPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type websiteBlogArchiveCreateResponse200 = {
  data: Article
  status: 200
}
    
export type websiteBlogArchiveCreateResponseSuccess = (websiteBlogArchiveCreateResponse200) & {
  headers: Headers;
};
;

export type websiteBlogArchiveCreateResponse = (websiteBlogArchiveCreateResponseSuccess)

export const getWebsiteBlogArchiveCreateUrl = (id: string,) => {


  

  return `/api/v1/website/blog/${id}/archive/`
}

export const websiteBlogArchiveCreate = async (id: string, options?: RequestInit): Promise<websiteBlogArchiveCreateResponse> => {
  
  return apiFetch<websiteBlogArchiveCreateResponse>(getWebsiteBlogArchiveCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getWebsiteBlogArchiveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogArchiveCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteBlogArchiveCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['websiteBlogArchiveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteBlogArchiveCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  websiteBlogArchiveCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteBlogArchiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteBlogArchiveCreate>>>
    
    export type WebsiteBlogArchiveCreateMutationError = unknown

    export const useWebsiteBlogArchiveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogArchiveCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteBlogArchiveCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getWebsiteBlogArchiveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Online now, or at a later date (scheduled). Only a reviewed article.
 */
export type websiteBlogPublishCreateResponse200 = {
  data: Article
  status: 200
}
    
export type websiteBlogPublishCreateResponseSuccess = (websiteBlogPublishCreateResponse200) & {
  headers: Headers;
};
;

export type websiteBlogPublishCreateResponse = (websiteBlogPublishCreateResponseSuccess)

export const getWebsiteBlogPublishCreateUrl = (id: string,) => {


  

  return `/api/v1/website/blog/${id}/publish/`
}

export const websiteBlogPublishCreate = async (id: string,
    publishRequest: PublishRequest, options?: RequestInit): Promise<websiteBlogPublishCreateResponse> => {
  
  return apiFetch<websiteBlogPublishCreateResponse>(getWebsiteBlogPublishCreateUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      publishRequest,)
  }
);}




export const getWebsiteBlogPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogPublishCreate>>, TError,{id: string;data: PublishRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteBlogPublishCreate>>, TError,{id: string;data: PublishRequest}, TContext> => {

const mutationKey = ['websiteBlogPublishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteBlogPublishCreate>>, {id: string;data: PublishRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  websiteBlogPublishCreate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteBlogPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteBlogPublishCreate>>>
    export type WebsiteBlogPublishCreateMutationBody = PublishRequest
    export type WebsiteBlogPublishCreateMutationError = unknown

    export const useWebsiteBlogPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogPublishCreate>>, TError,{id: string;data: PublishRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteBlogPublishCreate>>,
        TError,
        {id: string;data: PublishRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteBlogPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Back to draft (a new review is then needed before publishing again).
 */
export type websiteBlogReopenCreateResponse200 = {
  data: Article
  status: 200
}
    
export type websiteBlogReopenCreateResponseSuccess = (websiteBlogReopenCreateResponse200) & {
  headers: Headers;
};
;

export type websiteBlogReopenCreateResponse = (websiteBlogReopenCreateResponseSuccess)

export const getWebsiteBlogReopenCreateUrl = (id: string,) => {


  

  return `/api/v1/website/blog/${id}/reopen/`
}

export const websiteBlogReopenCreate = async (id: string, options?: RequestInit): Promise<websiteBlogReopenCreateResponse> => {
  
  return apiFetch<websiteBlogReopenCreateResponse>(getWebsiteBlogReopenCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getWebsiteBlogReopenCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogReopenCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteBlogReopenCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['websiteBlogReopenCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteBlogReopenCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  websiteBlogReopenCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteBlogReopenCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteBlogReopenCreate>>>
    
    export type WebsiteBlogReopenCreateMutationError = unknown

    export const useWebsiteBlogReopenCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogReopenCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteBlogReopenCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getWebsiteBlogReopenCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * A person has read the article (checked facts, sources and tone): « reviewed ».
 */
export type websiteBlogReviewCreateResponse200 = {
  data: Article
  status: 200
}
    
export type websiteBlogReviewCreateResponseSuccess = (websiteBlogReviewCreateResponse200) & {
  headers: Headers;
};
;

export type websiteBlogReviewCreateResponse = (websiteBlogReviewCreateResponseSuccess)

export const getWebsiteBlogReviewCreateUrl = (id: string,) => {


  

  return `/api/v1/website/blog/${id}/review/`
}

export const websiteBlogReviewCreate = async (id: string, options?: RequestInit): Promise<websiteBlogReviewCreateResponse> => {
  
  return apiFetch<websiteBlogReviewCreateResponse>(getWebsiteBlogReviewCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getWebsiteBlogReviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogReviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteBlogReviewCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['websiteBlogReviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteBlogReviewCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  websiteBlogReviewCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteBlogReviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteBlogReviewCreate>>>
    
    export type WebsiteBlogReviewCreateMutationError = unknown

    export const useWebsiteBlogReviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogReviewCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteBlogReviewCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getWebsiteBlogReviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type websiteBlogUnpublishCreateResponse200 = {
  data: Article
  status: 200
}
    
export type websiteBlogUnpublishCreateResponseSuccess = (websiteBlogUnpublishCreateResponse200) & {
  headers: Headers;
};
;

export type websiteBlogUnpublishCreateResponse = (websiteBlogUnpublishCreateResponseSuccess)

export const getWebsiteBlogUnpublishCreateUrl = (id: string,) => {


  

  return `/api/v1/website/blog/${id}/unpublish/`
}

export const websiteBlogUnpublishCreate = async (id: string, options?: RequestInit): Promise<websiteBlogUnpublishCreateResponse> => {
  
  return apiFetch<websiteBlogUnpublishCreateResponse>(getWebsiteBlogUnpublishCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getWebsiteBlogUnpublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogUnpublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteBlogUnpublishCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['websiteBlogUnpublishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteBlogUnpublishCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  websiteBlogUnpublishCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteBlogUnpublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteBlogUnpublishCreate>>>
    
    export type WebsiteBlogUnpublishCreateMutationError = unknown

    export const useWebsiteBlogUnpublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogUnpublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteBlogUnpublishCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getWebsiteBlogUnpublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * « Proposer un brouillon avec l'IA »: a draft written in the background.
 */
export type websiteBlogAiDraftCreateResponse202 = {
  data: Article
  status: 202
}
    
export type websiteBlogAiDraftCreateResponseSuccess = (websiteBlogAiDraftCreateResponse202) & {
  headers: Headers;
};
;

export type websiteBlogAiDraftCreateResponse = (websiteBlogAiDraftCreateResponseSuccess)

export const getWebsiteBlogAiDraftCreateUrl = () => {


  

  return `/api/v1/website/blog/ai-draft/`
}

export const websiteBlogAiDraftCreate = async (aiDraftRequest: AiDraftRequest, options?: RequestInit): Promise<websiteBlogAiDraftCreateResponse> => {
  
  return apiFetch<websiteBlogAiDraftCreateResponse>(getWebsiteBlogAiDraftCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      aiDraftRequest,)
  }
);}




export const getWebsiteBlogAiDraftCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogAiDraftCreate>>, TError,{data: AiDraftRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteBlogAiDraftCreate>>, TError,{data: AiDraftRequest}, TContext> => {

const mutationKey = ['websiteBlogAiDraftCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteBlogAiDraftCreate>>, {data: AiDraftRequest}> = (props) => {
          const {data} = props ?? {};

          return  websiteBlogAiDraftCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteBlogAiDraftCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteBlogAiDraftCreate>>>
    export type WebsiteBlogAiDraftCreateMutationBody = AiDraftRequest
    export type WebsiteBlogAiDraftCreateMutationError = unknown

    export const useWebsiteBlogAiDraftCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogAiDraftCreate>>, TError,{data: AiDraftRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteBlogAiDraftCreate>>,
        TError,
        {data: AiDraftRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteBlogAiDraftCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The Markdown as the site shows it (same safe renderer).
 */
export type websiteBlogPreviewCreateResponse200 = {
  data: PreviewResult
  status: 200
}
    
export type websiteBlogPreviewCreateResponseSuccess = (websiteBlogPreviewCreateResponse200) & {
  headers: Headers;
};
;

export type websiteBlogPreviewCreateResponse = (websiteBlogPreviewCreateResponseSuccess)

export const getWebsiteBlogPreviewCreateUrl = () => {


  

  return `/api/v1/website/blog/preview/`
}

export const websiteBlogPreviewCreate = async (previewRequest: PreviewRequest, options?: RequestInit): Promise<websiteBlogPreviewCreateResponse> => {
  
  return apiFetch<websiteBlogPreviewCreateResponse>(getWebsiteBlogPreviewCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      previewRequest,)
  }
);}




export const getWebsiteBlogPreviewCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogPreviewCreate>>, TError,{data: PreviewRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteBlogPreviewCreate>>, TError,{data: PreviewRequest}, TContext> => {

const mutationKey = ['websiteBlogPreviewCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteBlogPreviewCreate>>, {data: PreviewRequest}> = (props) => {
          const {data} = props ?? {};

          return  websiteBlogPreviewCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteBlogPreviewCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteBlogPreviewCreate>>>
    export type WebsiteBlogPreviewCreateMutationBody = PreviewRequest
    export type WebsiteBlogPreviewCreateMutationError = unknown

    export const useWebsiteBlogPreviewCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteBlogPreviewCreate>>, TError,{data: PreviewRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteBlogPreviewCreate>>,
        TError,
        {data: PreviewRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteBlogPreviewCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * The agency's texts of each city page; the facts stay in the versioned data.
 */
export type websiteLocalPagesListResponse200 = {
  data: LocalPage[]
  status: 200
}
    
export type websiteLocalPagesListResponseSuccess = (websiteLocalPagesListResponse200) & {
  headers: Headers;
};
;

export type websiteLocalPagesListResponse = (websiteLocalPagesListResponseSuccess)

export const getWebsiteLocalPagesListUrl = () => {


  

  return `/api/v1/website/local-pages/`
}

export const websiteLocalPagesList = async ( options?: RequestInit): Promise<websiteLocalPagesListResponse> => {
  
  return apiFetch<websiteLocalPagesListResponse>(getWebsiteLocalPagesListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteLocalPagesListQueryKey = () => {
    return [
    `/api/v1/website/local-pages/`
    ] as const;
    }

    
export const getWebsiteLocalPagesListQueryOptions = <TData = Awaited<ReturnType<typeof websiteLocalPagesList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteLocalPagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteLocalPagesListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteLocalPagesList>>> = ({ signal }) => websiteLocalPagesList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteLocalPagesList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteLocalPagesListQueryResult = NonNullable<Awaited<ReturnType<typeof websiteLocalPagesList>>>
export type WebsiteLocalPagesListQueryError = unknown


export function useWebsiteLocalPagesList<TData = Awaited<ReturnType<typeof websiteLocalPagesList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteLocalPagesList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteLocalPagesList>>,
          TError,
          Awaited<ReturnType<typeof websiteLocalPagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteLocalPagesList<TData = Awaited<ReturnType<typeof websiteLocalPagesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteLocalPagesList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteLocalPagesList>>,
          TError,
          Awaited<ReturnType<typeof websiteLocalPagesList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteLocalPagesList<TData = Awaited<ReturnType<typeof websiteLocalPagesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteLocalPagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteLocalPagesList<TData = Awaited<ReturnType<typeof websiteLocalPagesList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteLocalPagesList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteLocalPagesListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The agency's texts of each city page; the facts stay in the versioned data.
 */
export type websiteLocalPagesRetrieveResponse200 = {
  data: LocalPage
  status: 200
}
    
export type websiteLocalPagesRetrieveResponseSuccess = (websiteLocalPagesRetrieveResponse200) & {
  headers: Headers;
};
;

export type websiteLocalPagesRetrieveResponse = (websiteLocalPagesRetrieveResponseSuccess)

export const getWebsiteLocalPagesRetrieveUrl = (id: string,) => {


  

  return `/api/v1/website/local-pages/${id}/`
}

export const websiteLocalPagesRetrieve = async (id: string, options?: RequestInit): Promise<websiteLocalPagesRetrieveResponse> => {
  
  return apiFetch<websiteLocalPagesRetrieveResponse>(getWebsiteLocalPagesRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteLocalPagesRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/website/local-pages/${id}/`
    ] as const;
    }

    
export const getWebsiteLocalPagesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteLocalPagesRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>> = ({ signal }) => websiteLocalPagesRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteLocalPagesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>>
export type WebsiteLocalPagesRetrieveQueryError = unknown


export function useWebsiteLocalPagesRetrieve<TData = Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteLocalPagesRetrieve<TData = Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteLocalPagesRetrieve<TData = Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteLocalPagesRetrieve<TData = Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteLocalPagesRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteLocalPagesRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The agency's texts of each city page; the facts stay in the versioned data.
 */
export type websiteLocalPagesPartialUpdateResponse200 = {
  data: LocalPage
  status: 200
}
    
export type websiteLocalPagesPartialUpdateResponseSuccess = (websiteLocalPagesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type websiteLocalPagesPartialUpdateResponse = (websiteLocalPagesPartialUpdateResponseSuccess)

export const getWebsiteLocalPagesPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/website/local-pages/${id}/`
}

export const websiteLocalPagesPartialUpdate = async (id: string,
    patchedLocalPageRequest: PatchedLocalPageRequest, options?: RequestInit): Promise<websiteLocalPagesPartialUpdateResponse> => {
  
  return apiFetch<websiteLocalPagesPartialUpdateResponse>(getWebsiteLocalPagesPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedLocalPageRequest,)
  }
);}




export const getWebsiteLocalPagesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteLocalPagesPartialUpdate>>, TError,{id: string;data: PatchedLocalPageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteLocalPagesPartialUpdate>>, TError,{id: string;data: PatchedLocalPageRequest}, TContext> => {

const mutationKey = ['websiteLocalPagesPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteLocalPagesPartialUpdate>>, {id: string;data: PatchedLocalPageRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  websiteLocalPagesPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteLocalPagesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteLocalPagesPartialUpdate>>>
    export type WebsiteLocalPagesPartialUpdateMutationBody = PatchedLocalPageRequest
    export type WebsiteLocalPagesPartialUpdateMutationError = unknown

    export const useWebsiteLocalPagesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteLocalPagesPartialUpdate>>, TError,{id: string;data: PatchedLocalPageRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteLocalPagesPartialUpdate>>,
        TError,
        {id: string;data: PatchedLocalPageRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteLocalPagesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Upload (multipart): the file is re-encoded in the background; sending again for the same
place replaces the previous medium. Deleting brings the default medium back.
 */
export type websiteMediaListResponse200 = {
  data: SiteMedia[]
  status: 200
}
    
export type websiteMediaListResponseSuccess = (websiteMediaListResponse200) & {
  headers: Headers;
};
;

export type websiteMediaListResponse = (websiteMediaListResponseSuccess)

export const getWebsiteMediaListUrl = () => {


  

  return `/api/v1/website/media/`
}

export const websiteMediaList = async ( options?: RequestInit): Promise<websiteMediaListResponse> => {
  
  return apiFetch<websiteMediaListResponse>(getWebsiteMediaListUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteMediaListQueryKey = () => {
    return [
    `/api/v1/website/media/`
    ] as const;
    }

    
export const getWebsiteMediaListQueryOptions = <TData = Awaited<ReturnType<typeof websiteMediaList>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteMediaList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteMediaListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteMediaList>>> = ({ signal }) => websiteMediaList({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteMediaList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteMediaListQueryResult = NonNullable<Awaited<ReturnType<typeof websiteMediaList>>>
export type WebsiteMediaListQueryError = unknown


export function useWebsiteMediaList<TData = Awaited<ReturnType<typeof websiteMediaList>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteMediaList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteMediaList>>,
          TError,
          Awaited<ReturnType<typeof websiteMediaList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteMediaList<TData = Awaited<ReturnType<typeof websiteMediaList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteMediaList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteMediaList>>,
          TError,
          Awaited<ReturnType<typeof websiteMediaList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteMediaList<TData = Awaited<ReturnType<typeof websiteMediaList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteMediaList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteMediaList<TData = Awaited<ReturnType<typeof websiteMediaList>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteMediaList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteMediaListQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Upload (multipart): the file is re-encoded in the background; sending again for the same
place replaces the previous medium. Deleting brings the default medium back.
 */
export type websiteMediaCreateResponse201 = {
  data: SiteMedia
  status: 201
}
    
export type websiteMediaCreateResponseSuccess = (websiteMediaCreateResponse201) & {
  headers: Headers;
};
;

export type websiteMediaCreateResponse = (websiteMediaCreateResponseSuccess)

export const getWebsiteMediaCreateUrl = () => {


  

  return `/api/v1/website/media/`
}

export const websiteMediaCreate = async (siteMediaRequest: SiteMediaRequest, options?: RequestInit): Promise<websiteMediaCreateResponse> => {
    const formData = new FormData();
formData.append(`slot`, siteMediaRequest.slot)
formData.append(`original`, siteMediaRequest.original)

  return apiFetch<websiteMediaCreateResponse>(getWebsiteMediaCreateUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getWebsiteMediaCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteMediaCreate>>, TError,{data: SiteMediaRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteMediaCreate>>, TError,{data: SiteMediaRequest}, TContext> => {

const mutationKey = ['websiteMediaCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteMediaCreate>>, {data: SiteMediaRequest}> = (props) => {
          const {data} = props ?? {};

          return  websiteMediaCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteMediaCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteMediaCreate>>>
    export type WebsiteMediaCreateMutationBody = SiteMediaRequest
    export type WebsiteMediaCreateMutationError = unknown

    export const useWebsiteMediaCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteMediaCreate>>, TError,{data: SiteMediaRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteMediaCreate>>,
        TError,
        {data: SiteMediaRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteMediaCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Upload (multipart): the file is re-encoded in the background; sending again for the same
place replaces the previous medium. Deleting brings the default medium back.
 */
export type websiteMediaRetrieveResponse200 = {
  data: SiteMedia
  status: 200
}
    
export type websiteMediaRetrieveResponseSuccess = (websiteMediaRetrieveResponse200) & {
  headers: Headers;
};
;

export type websiteMediaRetrieveResponse = (websiteMediaRetrieveResponseSuccess)

export const getWebsiteMediaRetrieveUrl = (id: string,) => {


  

  return `/api/v1/website/media/${id}/`
}

export const websiteMediaRetrieve = async (id: string, options?: RequestInit): Promise<websiteMediaRetrieveResponse> => {
  
  return apiFetch<websiteMediaRetrieveResponse>(getWebsiteMediaRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteMediaRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/website/media/${id}/`
    ] as const;
    }

    
export const getWebsiteMediaRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof websiteMediaRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteMediaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteMediaRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteMediaRetrieve>>> = ({ signal }) => websiteMediaRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteMediaRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteMediaRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof websiteMediaRetrieve>>>
export type WebsiteMediaRetrieveQueryError = unknown


export function useWebsiteMediaRetrieve<TData = Awaited<ReturnType<typeof websiteMediaRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteMediaRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteMediaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteMediaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteMediaRetrieve<TData = Awaited<ReturnType<typeof websiteMediaRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteMediaRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteMediaRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteMediaRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteMediaRetrieve<TData = Awaited<ReturnType<typeof websiteMediaRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteMediaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteMediaRetrieve<TData = Awaited<ReturnType<typeof websiteMediaRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteMediaRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteMediaRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Upload (multipart): the file is re-encoded in the background; sending again for the same
place replaces the previous medium. Deleting brings the default medium back.
 */
export type websiteMediaDestroyResponse204 = {
  data: void
  status: 204
}
    
export type websiteMediaDestroyResponseSuccess = (websiteMediaDestroyResponse204) & {
  headers: Headers;
};
;

export type websiteMediaDestroyResponse = (websiteMediaDestroyResponseSuccess)

export const getWebsiteMediaDestroyUrl = (id: string,) => {


  

  return `/api/v1/website/media/${id}/`
}

export const websiteMediaDestroy = async (id: string, options?: RequestInit): Promise<websiteMediaDestroyResponse> => {
  
  return apiFetch<websiteMediaDestroyResponse>(getWebsiteMediaDestroyUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getWebsiteMediaDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteMediaDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteMediaDestroy>>, TError,{id: string}, TContext> => {

const mutationKey = ['websiteMediaDestroy'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteMediaDestroy>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  websiteMediaDestroy(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteMediaDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof websiteMediaDestroy>>>
    
    export type WebsiteMediaDestroyMutationError = unknown

    export const useWebsiteMediaDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteMediaDestroy>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteMediaDestroy>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getWebsiteMediaDestroyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type websiteOffersListResponse200 = {
  data: PaginatedOfferList
  status: 200
}
    
export type websiteOffersListResponseSuccess = (websiteOffersListResponse200) & {
  headers: Headers;
};
;

export type websiteOffersListResponse = (websiteOffersListResponseSuccess)

export const getWebsiteOffersListUrl = (params?: WebsiteOffersListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/website/offers/?${stringifiedParams}` : `/api/v1/website/offers/`
}

export const websiteOffersList = async (params?: WebsiteOffersListParams, options?: RequestInit): Promise<websiteOffersListResponse> => {
  
  return apiFetch<websiteOffersListResponse>(getWebsiteOffersListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteOffersListQueryKey = (params?: WebsiteOffersListParams,) => {
    return [
    `/api/v1/website/offers/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getWebsiteOffersListQueryOptions = <TData = Awaited<ReturnType<typeof websiteOffersList>>, TError = unknown>(params?: WebsiteOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteOffersListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteOffersList>>> = ({ signal }) => websiteOffersList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteOffersList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteOffersListQueryResult = NonNullable<Awaited<ReturnType<typeof websiteOffersList>>>
export type WebsiteOffersListQueryError = unknown


export function useWebsiteOffersList<TData = Awaited<ReturnType<typeof websiteOffersList>>, TError = unknown>(
 params: undefined |  WebsiteOffersListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteOffersList>>,
          TError,
          Awaited<ReturnType<typeof websiteOffersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteOffersList<TData = Awaited<ReturnType<typeof websiteOffersList>>, TError = unknown>(
 params?: WebsiteOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteOffersList>>,
          TError,
          Awaited<ReturnType<typeof websiteOffersList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteOffersList<TData = Awaited<ReturnType<typeof websiteOffersList>>, TError = unknown>(
 params?: WebsiteOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteOffersList<TData = Awaited<ReturnType<typeof websiteOffersList>>, TError = unknown>(
 params?: WebsiteOffersListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteOffersListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type websiteOffersCreateResponse201 = {
  data: Offer
  status: 201
}
    
export type websiteOffersCreateResponseSuccess = (websiteOffersCreateResponse201) & {
  headers: Headers;
};
;

export type websiteOffersCreateResponse = (websiteOffersCreateResponseSuccess)

export const getWebsiteOffersCreateUrl = () => {


  

  return `/api/v1/website/offers/`
}

export const websiteOffersCreate = async (offerRequest: OfferRequest, options?: RequestInit): Promise<websiteOffersCreateResponse> => {
  
  return apiFetch<websiteOffersCreateResponse>(getWebsiteOffersCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      offerRequest,)
  }
);}




export const getWebsiteOffersCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteOffersCreate>>, TError,{data: OfferRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteOffersCreate>>, TError,{data: OfferRequest}, TContext> => {

const mutationKey = ['websiteOffersCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteOffersCreate>>, {data: OfferRequest}> = (props) => {
          const {data} = props ?? {};

          return  websiteOffersCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteOffersCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteOffersCreate>>>
    export type WebsiteOffersCreateMutationBody = OfferRequest
    export type WebsiteOffersCreateMutationError = unknown

    export const useWebsiteOffersCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteOffersCreate>>, TError,{data: OfferRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteOffersCreate>>,
        TError,
        {data: OfferRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteOffersCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type websiteOffersRetrieveResponse200 = {
  data: Offer
  status: 200
}
    
export type websiteOffersRetrieveResponseSuccess = (websiteOffersRetrieveResponse200) & {
  headers: Headers;
};
;

export type websiteOffersRetrieveResponse = (websiteOffersRetrieveResponseSuccess)

export const getWebsiteOffersRetrieveUrl = (id: string,) => {


  

  return `/api/v1/website/offers/${id}/`
}

export const websiteOffersRetrieve = async (id: string, options?: RequestInit): Promise<websiteOffersRetrieveResponse> => {
  
  return apiFetch<websiteOffersRetrieveResponse>(getWebsiteOffersRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteOffersRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/website/offers/${id}/`
    ] as const;
    }

    
export const getWebsiteOffersRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof websiteOffersRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteOffersRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteOffersRetrieve>>> = ({ signal }) => websiteOffersRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteOffersRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteOffersRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof websiteOffersRetrieve>>>
export type WebsiteOffersRetrieveQueryError = unknown


export function useWebsiteOffersRetrieve<TData = Awaited<ReturnType<typeof websiteOffersRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteOffersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteOffersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteOffersRetrieve<TData = Awaited<ReturnType<typeof websiteOffersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteOffersRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteOffersRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteOffersRetrieve<TData = Awaited<ReturnType<typeof websiteOffersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteOffersRetrieve<TData = Awaited<ReturnType<typeof websiteOffersRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteOffersRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type websiteOffersPartialUpdateResponse200 = {
  data: Offer
  status: 200
}
    
export type websiteOffersPartialUpdateResponseSuccess = (websiteOffersPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type websiteOffersPartialUpdateResponse = (websiteOffersPartialUpdateResponseSuccess)

export const getWebsiteOffersPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/website/offers/${id}/`
}

export const websiteOffersPartialUpdate = async (id: string,
    patchedOfferRequest: PatchedOfferRequest, options?: RequestInit): Promise<websiteOffersPartialUpdateResponse> => {
  
  return apiFetch<websiteOffersPartialUpdateResponse>(getWebsiteOffersPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedOfferRequest,)
  }
);}




export const getWebsiteOffersPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteOffersPartialUpdate>>, TError,{id: string;data: PatchedOfferRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteOffersPartialUpdate>>, TError,{id: string;data: PatchedOfferRequest}, TContext> => {

const mutationKey = ['websiteOffersPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteOffersPartialUpdate>>, {id: string;data: PatchedOfferRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  websiteOffersPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteOffersPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteOffersPartialUpdate>>>
    export type WebsiteOffersPartialUpdateMutationBody = PatchedOfferRequest
    export type WebsiteOffersPartialUpdateMutationError = unknown

    export const useWebsiteOffersPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteOffersPartialUpdate>>, TError,{id: string;data: PatchedOfferRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteOffersPartialUpdate>>,
        TError,
        {id: string;data: PatchedOfferRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteOffersPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type websiteOffersArchiveCreateResponse200 = {
  data: Offer
  status: 200
}
    
export type websiteOffersArchiveCreateResponseSuccess = (websiteOffersArchiveCreateResponse200) & {
  headers: Headers;
};
;

export type websiteOffersArchiveCreateResponse = (websiteOffersArchiveCreateResponseSuccess)

export const getWebsiteOffersArchiveCreateUrl = (id: string,) => {


  

  return `/api/v1/website/offers/${id}/archive/`
}

export const websiteOffersArchiveCreate = async (id: string, options?: RequestInit): Promise<websiteOffersArchiveCreateResponse> => {
  
  return apiFetch<websiteOffersArchiveCreateResponse>(getWebsiteOffersArchiveCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getWebsiteOffersArchiveCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteOffersArchiveCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteOffersArchiveCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['websiteOffersArchiveCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteOffersArchiveCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  websiteOffersArchiveCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteOffersArchiveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteOffersArchiveCreate>>>
    
    export type WebsiteOffersArchiveCreateMutationError = unknown

    export const useWebsiteOffersArchiveCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteOffersArchiveCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteOffersArchiveCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getWebsiteOffersArchiveCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Page online, WhatsApp link with the code, QR code, flyer PDF, 3 ad copies (P1B-06).
 */
export type websiteOffersPublishCreateResponse200 = {
  data: Offer
  status: 200
}
    
export type websiteOffersPublishCreateResponseSuccess = (websiteOffersPublishCreateResponse200) & {
  headers: Headers;
};
;

export type websiteOffersPublishCreateResponse = (websiteOffersPublishCreateResponseSuccess)

export const getWebsiteOffersPublishCreateUrl = (id: string,) => {


  

  return `/api/v1/website/offers/${id}/publish/`
}

export const websiteOffersPublishCreate = async (id: string, options?: RequestInit): Promise<websiteOffersPublishCreateResponse> => {
  
  return apiFetch<websiteOffersPublishCreateResponse>(getWebsiteOffersPublishCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getWebsiteOffersPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteOffersPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteOffersPublishCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['websiteOffersPublishCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteOffersPublishCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  websiteOffersPublishCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteOffersPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteOffersPublishCreate>>>
    
    export type WebsiteOffersPublishCreateMutationError = unknown

    export const useWebsiteOffersPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteOffersPublishCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteOffersPublishCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getWebsiteOffersPublishCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type websiteOffersQrRetrieveResponse200 = {
  data: string
  status: 200
}
    
export type websiteOffersQrRetrieveResponseSuccess = (websiteOffersQrRetrieveResponse200) & {
  headers: Headers;
};
;

export type websiteOffersQrRetrieveResponse = (websiteOffersQrRetrieveResponseSuccess)

export const getWebsiteOffersQrRetrieveUrl = (id: string,) => {


  

  return `/api/v1/website/offers/${id}/qr/`
}

export const websiteOffersQrRetrieve = async (id: string, options?: RequestInit): Promise<websiteOffersQrRetrieveResponse> => {
  
  return apiFetch<websiteOffersQrRetrieveResponse>(getWebsiteOffersQrRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteOffersQrRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/website/offers/${id}/qr/`
    ] as const;
    }

    
export const getWebsiteOffersQrRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof websiteOffersQrRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersQrRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteOffersQrRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteOffersQrRetrieve>>> = ({ signal }) => websiteOffersQrRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteOffersQrRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteOffersQrRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof websiteOffersQrRetrieve>>>
export type WebsiteOffersQrRetrieveQueryError = unknown


export function useWebsiteOffersQrRetrieve<TData = Awaited<ReturnType<typeof websiteOffersQrRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersQrRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteOffersQrRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteOffersQrRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteOffersQrRetrieve<TData = Awaited<ReturnType<typeof websiteOffersQrRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersQrRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteOffersQrRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteOffersQrRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteOffersQrRetrieve<TData = Awaited<ReturnType<typeof websiteOffersQrRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersQrRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteOffersQrRetrieve<TData = Awaited<ReturnType<typeof websiteOffersQrRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteOffersQrRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteOffersQrRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * P1B-09: a text changed here is online at the next page view (no deployment).
 */
export type websiteSectionsListResponse200 = {
  data: SiteSection[]
  status: 200
}
    
export type websiteSectionsListResponseSuccess = (websiteSectionsListResponse200) & {
  headers: Headers;
};
;

export type websiteSectionsListResponse = (websiteSectionsListResponseSuccess)

export const getWebsiteSectionsListUrl = (params?: WebsiteSectionsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/website/sections/?${stringifiedParams}` : `/api/v1/website/sections/`
}

export const websiteSectionsList = async (params?: WebsiteSectionsListParams, options?: RequestInit): Promise<websiteSectionsListResponse> => {
  
  return apiFetch<websiteSectionsListResponse>(getWebsiteSectionsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteSectionsListQueryKey = (params?: WebsiteSectionsListParams,) => {
    return [
    `/api/v1/website/sections/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getWebsiteSectionsListQueryOptions = <TData = Awaited<ReturnType<typeof websiteSectionsList>>, TError = unknown>(params?: WebsiteSectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSectionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteSectionsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteSectionsList>>> = ({ signal }) => websiteSectionsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteSectionsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteSectionsListQueryResult = NonNullable<Awaited<ReturnType<typeof websiteSectionsList>>>
export type WebsiteSectionsListQueryError = unknown


export function useWebsiteSectionsList<TData = Awaited<ReturnType<typeof websiteSectionsList>>, TError = unknown>(
 params: undefined |  WebsiteSectionsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSectionsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteSectionsList>>,
          TError,
          Awaited<ReturnType<typeof websiteSectionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteSectionsList<TData = Awaited<ReturnType<typeof websiteSectionsList>>, TError = unknown>(
 params?: WebsiteSectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSectionsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteSectionsList>>,
          TError,
          Awaited<ReturnType<typeof websiteSectionsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteSectionsList<TData = Awaited<ReturnType<typeof websiteSectionsList>>, TError = unknown>(
 params?: WebsiteSectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSectionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteSectionsList<TData = Awaited<ReturnType<typeof websiteSectionsList>>, TError = unknown>(
 params?: WebsiteSectionsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSectionsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteSectionsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * P1B-09: a text changed here is online at the next page view (no deployment).
 */
export type websiteSectionsRetrieveResponse200 = {
  data: SiteSection
  status: 200
}
    
export type websiteSectionsRetrieveResponseSuccess = (websiteSectionsRetrieveResponse200) & {
  headers: Headers;
};
;

export type websiteSectionsRetrieveResponse = (websiteSectionsRetrieveResponseSuccess)

export const getWebsiteSectionsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/website/sections/${id}/`
}

export const websiteSectionsRetrieve = async (id: string, options?: RequestInit): Promise<websiteSectionsRetrieveResponse> => {
  
  return apiFetch<websiteSectionsRetrieveResponse>(getWebsiteSectionsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteSectionsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/website/sections/${id}/`
    ] as const;
    }

    
export const getWebsiteSectionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof websiteSectionsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSectionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteSectionsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteSectionsRetrieve>>> = ({ signal }) => websiteSectionsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteSectionsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteSectionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof websiteSectionsRetrieve>>>
export type WebsiteSectionsRetrieveQueryError = unknown


export function useWebsiteSectionsRetrieve<TData = Awaited<ReturnType<typeof websiteSectionsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSectionsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteSectionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteSectionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteSectionsRetrieve<TData = Awaited<ReturnType<typeof websiteSectionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSectionsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteSectionsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteSectionsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteSectionsRetrieve<TData = Awaited<ReturnType<typeof websiteSectionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSectionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteSectionsRetrieve<TData = Awaited<ReturnType<typeof websiteSectionsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSectionsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteSectionsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * P1B-09: a text changed here is online at the next page view (no deployment).
 */
export type websiteSectionsPartialUpdateResponse200 = {
  data: SiteSection
  status: 200
}
    
export type websiteSectionsPartialUpdateResponseSuccess = (websiteSectionsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type websiteSectionsPartialUpdateResponse = (websiteSectionsPartialUpdateResponseSuccess)

export const getWebsiteSectionsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/website/sections/${id}/`
}

export const websiteSectionsPartialUpdate = async (id: string,
    patchedSiteSectionRequest: PatchedSiteSectionRequest, options?: RequestInit): Promise<websiteSectionsPartialUpdateResponse> => {
  
  return apiFetch<websiteSectionsPartialUpdateResponse>(getWebsiteSectionsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedSiteSectionRequest,)
  }
);}




export const getWebsiteSectionsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteSectionsPartialUpdate>>, TError,{id: string;data: PatchedSiteSectionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteSectionsPartialUpdate>>, TError,{id: string;data: PatchedSiteSectionRequest}, TContext> => {

const mutationKey = ['websiteSectionsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteSectionsPartialUpdate>>, {id: string;data: PatchedSiteSectionRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  websiteSectionsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteSectionsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteSectionsPartialUpdate>>>
    export type WebsiteSectionsPartialUpdateMutationBody = PatchedSiteSectionRequest
    export type WebsiteSectionsPartialUpdateMutationError = unknown

    export const useWebsiteSectionsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteSectionsPartialUpdate>>, TError,{id: string;data: PatchedSiteSectionRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteSectionsPartialUpdate>>,
        TError,
        {id: string;data: PatchedSiteSectionRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteSectionsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export type websiteSettingsListResponse200 = {
  data: PaginatedWebsiteSettingsList
  status: 200
}
    
export type websiteSettingsListResponseSuccess = (websiteSettingsListResponse200) & {
  headers: Headers;
};
;

export type websiteSettingsListResponse = (websiteSettingsListResponseSuccess)

export const getWebsiteSettingsListUrl = (params?: WebsiteSettingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/website/settings/?${stringifiedParams}` : `/api/v1/website/settings/`
}

export const websiteSettingsList = async (params?: WebsiteSettingsListParams, options?: RequestInit): Promise<websiteSettingsListResponse> => {
  
  return apiFetch<websiteSettingsListResponse>(getWebsiteSettingsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteSettingsListQueryKey = (params?: WebsiteSettingsListParams,) => {
    return [
    `/api/v1/website/settings/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getWebsiteSettingsListQueryOptions = <TData = Awaited<ReturnType<typeof websiteSettingsList>>, TError = unknown>(params?: WebsiteSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteSettingsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteSettingsList>>> = ({ signal }) => websiteSettingsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteSettingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteSettingsListQueryResult = NonNullable<Awaited<ReturnType<typeof websiteSettingsList>>>
export type WebsiteSettingsListQueryError = unknown


export function useWebsiteSettingsList<TData = Awaited<ReturnType<typeof websiteSettingsList>>, TError = unknown>(
 params: undefined |  WebsiteSettingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSettingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteSettingsList>>,
          TError,
          Awaited<ReturnType<typeof websiteSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteSettingsList<TData = Awaited<ReturnType<typeof websiteSettingsList>>, TError = unknown>(
 params?: WebsiteSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSettingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteSettingsList>>,
          TError,
          Awaited<ReturnType<typeof websiteSettingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteSettingsList<TData = Awaited<ReturnType<typeof websiteSettingsList>>, TError = unknown>(
 params?: WebsiteSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteSettingsList<TData = Awaited<ReturnType<typeof websiteSettingsList>>, TError = unknown>(
 params?: WebsiteSettingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSettingsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteSettingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type websiteSettingsRetrieveResponse200 = {
  data: WebsiteSettings
  status: 200
}
    
export type websiteSettingsRetrieveResponseSuccess = (websiteSettingsRetrieveResponse200) & {
  headers: Headers;
};
;

export type websiteSettingsRetrieveResponse = (websiteSettingsRetrieveResponseSuccess)

export const getWebsiteSettingsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/website/settings/${id}/`
}

export const websiteSettingsRetrieve = async (id: string, options?: RequestInit): Promise<websiteSettingsRetrieveResponse> => {
  
  return apiFetch<websiteSettingsRetrieveResponse>(getWebsiteSettingsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteSettingsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/website/settings/${id}/`
    ] as const;
    }

    
export const getWebsiteSettingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof websiteSettingsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteSettingsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteSettingsRetrieve>>> = ({ signal }) => websiteSettingsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteSettingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteSettingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof websiteSettingsRetrieve>>>
export type WebsiteSettingsRetrieveQueryError = unknown


export function useWebsiteSettingsRetrieve<TData = Awaited<ReturnType<typeof websiteSettingsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSettingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteSettingsRetrieve<TData = Awaited<ReturnType<typeof websiteSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSettingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteSettingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteSettingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteSettingsRetrieve<TData = Awaited<ReturnType<typeof websiteSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteSettingsRetrieve<TData = Awaited<ReturnType<typeof websiteSettingsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteSettingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteSettingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export type websiteSettingsPartialUpdateResponse200 = {
  data: WebsiteSettings
  status: 200
}
    
export type websiteSettingsPartialUpdateResponseSuccess = (websiteSettingsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type websiteSettingsPartialUpdateResponse = (websiteSettingsPartialUpdateResponseSuccess)

export const getWebsiteSettingsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/website/settings/${id}/`
}

export const websiteSettingsPartialUpdate = async (id: string,
    patchedWebsiteSettingsRequest: PatchedWebsiteSettingsRequest, options?: RequestInit): Promise<websiteSettingsPartialUpdateResponse> => {
  
  return apiFetch<websiteSettingsPartialUpdateResponse>(getWebsiteSettingsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedWebsiteSettingsRequest,)
  }
);}




export const getWebsiteSettingsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteSettingsPartialUpdate>>, TError,{id: string;data: PatchedWebsiteSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteSettingsPartialUpdate>>, TError,{id: string;data: PatchedWebsiteSettingsRequest}, TContext> => {

const mutationKey = ['websiteSettingsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteSettingsPartialUpdate>>, {id: string;data: PatchedWebsiteSettingsRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  websiteSettingsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteSettingsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteSettingsPartialUpdate>>>
    export type WebsiteSettingsPartialUpdateMutationBody = PatchedWebsiteSettingsRequest
    export type WebsiteSettingsPartialUpdateMutationError = unknown

    export const useWebsiteSettingsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteSettingsPartialUpdate>>, TError,{id: string;data: PatchedWebsiteSettingsRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteSettingsPartialUpdate>>,
        TError,
        {id: string;data: PatchedWebsiteSettingsRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteSettingsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shown on the site only with the client's written consent and after verification.
 */
export type websiteTestimonialsListResponse200 = {
  data: PaginatedTestimonialList
  status: 200
}
    
export type websiteTestimonialsListResponseSuccess = (websiteTestimonialsListResponse200) & {
  headers: Headers;
};
;

export type websiteTestimonialsListResponse = (websiteTestimonialsListResponseSuccess)

export const getWebsiteTestimonialsListUrl = (params?: WebsiteTestimonialsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/website/testimonials/?${stringifiedParams}` : `/api/v1/website/testimonials/`
}

export const websiteTestimonialsList = async (params?: WebsiteTestimonialsListParams, options?: RequestInit): Promise<websiteTestimonialsListResponse> => {
  
  return apiFetch<websiteTestimonialsListResponse>(getWebsiteTestimonialsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteTestimonialsListQueryKey = (params?: WebsiteTestimonialsListParams,) => {
    return [
    `/api/v1/website/testimonials/`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getWebsiteTestimonialsListQueryOptions = <TData = Awaited<ReturnType<typeof websiteTestimonialsList>>, TError = unknown>(params?: WebsiteTestimonialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteTestimonialsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteTestimonialsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteTestimonialsList>>> = ({ signal }) => websiteTestimonialsList(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteTestimonialsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteTestimonialsListQueryResult = NonNullable<Awaited<ReturnType<typeof websiteTestimonialsList>>>
export type WebsiteTestimonialsListQueryError = unknown


export function useWebsiteTestimonialsList<TData = Awaited<ReturnType<typeof websiteTestimonialsList>>, TError = unknown>(
 params: undefined |  WebsiteTestimonialsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteTestimonialsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteTestimonialsList>>,
          TError,
          Awaited<ReturnType<typeof websiteTestimonialsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteTestimonialsList<TData = Awaited<ReturnType<typeof websiteTestimonialsList>>, TError = unknown>(
 params?: WebsiteTestimonialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteTestimonialsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteTestimonialsList>>,
          TError,
          Awaited<ReturnType<typeof websiteTestimonialsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteTestimonialsList<TData = Awaited<ReturnType<typeof websiteTestimonialsList>>, TError = unknown>(
 params?: WebsiteTestimonialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteTestimonialsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteTestimonialsList<TData = Awaited<ReturnType<typeof websiteTestimonialsList>>, TError = unknown>(
 params?: WebsiteTestimonialsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteTestimonialsList>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteTestimonialsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shown on the site only with the client's written consent and after verification.
 */
export type websiteTestimonialsCreateResponse201 = {
  data: Testimonial
  status: 201
}
    
export type websiteTestimonialsCreateResponseSuccess = (websiteTestimonialsCreateResponse201) & {
  headers: Headers;
};
;

export type websiteTestimonialsCreateResponse = (websiteTestimonialsCreateResponseSuccess)

export const getWebsiteTestimonialsCreateUrl = () => {


  

  return `/api/v1/website/testimonials/`
}

export const websiteTestimonialsCreate = async (testimonialRequest: TestimonialRequest, options?: RequestInit): Promise<websiteTestimonialsCreateResponse> => {
  
  return apiFetch<websiteTestimonialsCreateResponse>(getWebsiteTestimonialsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      testimonialRequest,)
  }
);}




export const getWebsiteTestimonialsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteTestimonialsCreate>>, TError,{data: TestimonialRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteTestimonialsCreate>>, TError,{data: TestimonialRequest}, TContext> => {

const mutationKey = ['websiteTestimonialsCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteTestimonialsCreate>>, {data: TestimonialRequest}> = (props) => {
          const {data} = props ?? {};

          return  websiteTestimonialsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteTestimonialsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteTestimonialsCreate>>>
    export type WebsiteTestimonialsCreateMutationBody = TestimonialRequest
    export type WebsiteTestimonialsCreateMutationError = unknown

    export const useWebsiteTestimonialsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteTestimonialsCreate>>, TError,{data: TestimonialRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteTestimonialsCreate>>,
        TError,
        {data: TestimonialRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteTestimonialsCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shown on the site only with the client's written consent and after verification.
 */
export type websiteTestimonialsRetrieveResponse200 = {
  data: Testimonial
  status: 200
}
    
export type websiteTestimonialsRetrieveResponseSuccess = (websiteTestimonialsRetrieveResponse200) & {
  headers: Headers;
};
;

export type websiteTestimonialsRetrieveResponse = (websiteTestimonialsRetrieveResponseSuccess)

export const getWebsiteTestimonialsRetrieveUrl = (id: string,) => {


  

  return `/api/v1/website/testimonials/${id}/`
}

export const websiteTestimonialsRetrieve = async (id: string, options?: RequestInit): Promise<websiteTestimonialsRetrieveResponse> => {
  
  return apiFetch<websiteTestimonialsRetrieveResponse>(getWebsiteTestimonialsRetrieveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getWebsiteTestimonialsRetrieveQueryKey = (id?: string,) => {
    return [
    `/api/v1/website/testimonials/${id}/`
    ] as const;
    }

    
export const getWebsiteTestimonialsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getWebsiteTestimonialsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>> = ({ signal }) => websiteTestimonialsRetrieve(id, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type WebsiteTestimonialsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>>
export type WebsiteTestimonialsRetrieveQueryError = unknown


export function useWebsiteTestimonialsRetrieve<TData = Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteTestimonialsRetrieve<TData = Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useWebsiteTestimonialsRetrieve<TData = Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useWebsiteTestimonialsRetrieve<TData = Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof websiteTestimonialsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWebsiteTestimonialsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shown on the site only with the client's written consent and after verification.
 */
export type websiteTestimonialsPartialUpdateResponse200 = {
  data: Testimonial
  status: 200
}
    
export type websiteTestimonialsPartialUpdateResponseSuccess = (websiteTestimonialsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type websiteTestimonialsPartialUpdateResponse = (websiteTestimonialsPartialUpdateResponseSuccess)

export const getWebsiteTestimonialsPartialUpdateUrl = (id: string,) => {


  

  return `/api/v1/website/testimonials/${id}/`
}

export const websiteTestimonialsPartialUpdate = async (id: string,
    patchedTestimonialRequest: PatchedTestimonialRequest, options?: RequestInit): Promise<websiteTestimonialsPartialUpdateResponse> => {
  
  return apiFetch<websiteTestimonialsPartialUpdateResponse>(getWebsiteTestimonialsPartialUpdateUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      patchedTestimonialRequest,)
  }
);}




export const getWebsiteTestimonialsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteTestimonialsPartialUpdate>>, TError,{id: string;data: PatchedTestimonialRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteTestimonialsPartialUpdate>>, TError,{id: string;data: PatchedTestimonialRequest}, TContext> => {

const mutationKey = ['websiteTestimonialsPartialUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteTestimonialsPartialUpdate>>, {id: string;data: PatchedTestimonialRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  websiteTestimonialsPartialUpdate(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteTestimonialsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteTestimonialsPartialUpdate>>>
    export type WebsiteTestimonialsPartialUpdateMutationBody = PatchedTestimonialRequest
    export type WebsiteTestimonialsPartialUpdateMutationError = unknown

    export const useWebsiteTestimonialsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteTestimonialsPartialUpdate>>, TError,{id: string;data: PatchedTestimonialRequest}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteTestimonialsPartialUpdate>>,
        TError,
        {id: string;data: PatchedTestimonialRequest},
        TContext
      > => {

      const mutationOptions = getWebsiteTestimonialsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Shown on the site only with the client's written consent and after verification.
 */
export type websiteTestimonialsVerifyCreateResponse200 = {
  data: Testimonial
  status: 200
}
    
export type websiteTestimonialsVerifyCreateResponseSuccess = (websiteTestimonialsVerifyCreateResponse200) & {
  headers: Headers;
};
;

export type websiteTestimonialsVerifyCreateResponse = (websiteTestimonialsVerifyCreateResponseSuccess)

export const getWebsiteTestimonialsVerifyCreateUrl = (id: string,) => {


  

  return `/api/v1/website/testimonials/${id}/verify/`
}

export const websiteTestimonialsVerifyCreate = async (id: string, options?: RequestInit): Promise<websiteTestimonialsVerifyCreateResponse> => {
  
  return apiFetch<websiteTestimonialsVerifyCreateResponse>(getWebsiteTestimonialsVerifyCreateUrl(id),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getWebsiteTestimonialsVerifyCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteTestimonialsVerifyCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof websiteTestimonialsVerifyCreate>>, TError,{id: string}, TContext> => {

const mutationKey = ['websiteTestimonialsVerifyCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof websiteTestimonialsVerifyCreate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  websiteTestimonialsVerifyCreate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type WebsiteTestimonialsVerifyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof websiteTestimonialsVerifyCreate>>>
    
    export type WebsiteTestimonialsVerifyCreateMutationError = unknown

    export const useWebsiteTestimonialsVerifyCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof websiteTestimonialsVerifyCreate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof websiteTestimonialsVerifyCreate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getWebsiteTestimonialsVerifyCreateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    